import React from 'react';
import IconWrapper from '../../../../IconWrapper';
import { FiLayers } from 'react-icons/fi';
import ConductSummaryBlocks from '../../ConductSummaryBlocks';

type Props = {
  // Use any here to avoid cross-file generic inference issues in build; component enforces shape at runtime
  data: any;
  onLabelTap: (meta: any) => void;
};

const ConductSummarySection: React.FC<Props> = ({ data, onLabelTap }) => {
  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <IconWrapper icon={FiLayers} className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-bold text-gray-900">Conduct Signal Summary</span>
      </div>
      <ConductSummaryBlocks data={data as any} onLabelTap={onLabelTap} />
    </div>
  );
};

export default React.memo(ConductSummarySection);
